enum Tab {
  Portfolios = 'portfolios',
  Teams = 'teams',
  Boards = 'boards',
}

type MeasureConfig = {
  id: string;
  category: MeasureCategory;
  nameKey: string;
  isTrend: boolean;
  disabled: boolean;
};

enum MeasureCategory {
  TimeMetrics = 'timeMetrics',
  PerformanceMetrics = 'performanceMetrics',
  TaskProcessMetrics = 'taskProcessMetrics',
  QualityMetrics = 'qualityMetrics',
  ConsistencyMetrics = 'consistencyMetrics',
  ComplexityStrategy = 'complexityStrategy',
  DependencyIndependence = 'dependencyIndependence',
}

enum ChartType {
  Line = 'line',
  Bar = 'bar',
}

enum ViewMode {
  MeasureComparison = 'measure_comparison',
  Capacity = 'capacity',
  InitiativeOverview = 'initiative_overview',
  InitiativeCompletion = 'initiative_completion',
  InitiativeFocus = 'initiative_focus',
}

enum ComparisonMode {
  Single = 'single',
  Multiple = 'multiple',
}

type DateRange = {
  startDate: string;
  endDate: string;
};

type MeasureFilter = {
  id: string;
  name: string;
  category: MeasureCategory;
  enabled: boolean;
  isTrend: boolean;
  disabled?: boolean;
};

type KPICard = {
  id: string;
  title: string;
  icon: string;
  value: string | number;
  unit?: string;
  change?: {
    value: number;
    label: string;
    isPositive: boolean;
  };
  type: 'grade' | 'single_value' | 'numerical' | 'percentage';
};

type ChartDataset = {
  id: string;
  name: string;
  data: number[];
  color: string;
  type: 'line' | 'bar';
};

type ChartData = {
  labels: string[];
  datasets: ChartDataset[];
};

type ProcessAnalysisFilters = {
  timeMetrics: string[];
  performanceMetrics: string[];
  taskProcessMetrics: string[];
  qualityMetrics: string[];
  consistencyMetrics: string[];
  complexityStrategy: string[];
  dependencyIndependence: string[];
};

export { ChartType, ComparisonMode, MeasureCategory, Tab, ViewMode };
export type { ChartData, ChartDataset, DateRange, KPICard, MeasureConfig, MeasureFilter, ProcessAnalysisFilters };
